import React, { memo, useEffect, useState } from 'react';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot, ReportType } from '../../../models';
import {
  getDropDownFieldByValue,
  getReportypeSetting,
} from '../../find-report/report-setting';
import { fetchReportTypeSettingWithCache } from '../../../api';
import ReportSettingPIT from './ReportSettingPIT';
import { Icon } from '../../../components';
import { useFormatDateByLocale } from '../../../util/hooks/useFormatDateByLocale';

interface ReportSettingProps {
  reportSnapshot: ReportSnapshot;
}

function ReportSettingInforAP({
  reportSnapshot,
}: ReportSettingProps): JSX.Element {
  const {
    asOfDate1,
    asOfDate2,
    jurisdictionOption,
    newRulesRateId,
  } = reportSnapshot;

  const [leaseType, setLeaseType] = useState('');
  const [classification, setClassification] = useState('');
  const formattedAsOfDate1 = useFormatDateByLocale(asOfDate1);
  const formattedAsOfDate2 = useFormatDateByLocale(asOfDate2);

  useEffect(() => {
    const loadData = async (): Promise<void> => {
      const reportTypeSetting = await fetchReportTypeSettingWithCache(
        reportSnapshot.clientId,
      );
      const reportSetting = getReportypeSetting(
        reportTypeSetting,
        ReportType.ap,
      );
      const leaseTypeItem = getDropDownFieldByValue(
        reportSetting,
        'LeaseType',
        newRulesRateId,
      );
      const classificationItem = getDropDownFieldByValue(
        reportSetting,
        'Classification',
        jurisdictionOption,
      );

      setLeaseType(leaseTypeItem?.name);
      setClassification(classificationItem?.name);
    };
    loadData();
  }, [jurisdictionOption, newRulesRateId, reportSnapshot]);

  return (
    <>
      <Styled.ReportSettingItem hasSecondColumn={true}>
        <Icon name="calendar" />
        <GStyled.Text>From</GStyled.Text>
        <GStyled.Text fontWeight="medium">{formattedAsOfDate1}</GStyled.Text>
        <GStyled.Text>To</GStyled.Text>
        <GStyled.Text fontWeight="medium">{formattedAsOfDate2}</GStyled.Text>
      </Styled.ReportSettingItem>
      <ReportSettingPIT reportSnapshot={reportSnapshot} />
      <Styled.ReportSettingItem hasSecondColumn={true}>
        <Icon name="gear" />
        <GStyled.Text>Lease Type</GStyled.Text>
        <GStyled.Text fontWeight="medium">{leaseType}</GStyled.Text>
        <GStyled.Text>Classification</GStyled.Text>
        <GStyled.Text fontWeight="medium">{classification}</GStyled.Text>
      </Styled.ReportSettingItem>
    </>
  );
}

export default memo(ReportSettingInforAP);
